import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=1bb73ff8&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=ts"
export * from "./ArticleCard.vue?vue&type=script&lang=ts"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=1bb73ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_coffee-script@1.12.7_css-loader@5.2.7_webpa_35f4d3d5eaf4581d12c76a04842072e8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb73ff8",
  null
  
)

export default component.exports